import React, { lazy } from 'react'

export const InvestorPassedHistory = lazy(() =>
  import('../pages/Investor/InvestorDeals/InvestorPassedHistory'),
)
export const InvestorAnotherInvestment = lazy(() =>
  import('../pages/Investor/InvestorDeals/AnotherInvestment'),
)
export const SignUpInvestor = React.lazy(() => import('../pages/Investor/SignUpInvestor/SignUpInvestor'))

export const InvestorProfile = React.lazy(() => import('../pages/Investor/InvestorProfile/InvestorProfile'))
export const InvestorPremiumPlans = React.lazy(() =>
  import('../pages/Investor/InvestorPremiumPlans/InvestorPremiumPlans'),
)
export const InvestorDealDetail = React.lazy(() =>
  import('../pages/Investor/InvestorDeals/InvestorDealDetail'),
)
export const InvestorInvestedDealDetail = React.lazy(() =>
  import('../pages/Investor/InvestorDeals/InvestorInvestedDealDetail'),
)
export const MonthlyUpdates = React.lazy(() => import('../pages/Investor/InvestorDeals/MonthlyUpdates'))
export const MonthlyUpdatesAnalytics = React.lazy(() =>
  import('../pages/Investor/InvestorDeals/MonthlyUpdatesAnalytics'),
)

export const PassDeal = React.lazy(() => import('../pages/Investor/InvestorDeals/PassDeal'))
export const InvestorRationale = React.lazy(() =>
  import('../pages/Investor/InvestorRationale/InvestorRationale'),
)
export const PublicQAForum = React.lazy(() => import('../pages/Investor/InvestorDeals/PublicQAForum'))
export const ReviewMemo = React.lazy(() => import('../pages/Investor/InvestorDeals/ReviewMemo'))

export const InvestorInvestingSteps = React.lazy(() =>
  import('../pages/Investor/InvestorDeals/InvestorInvestingStepsFlow/InvestorInvestingStepsFlow'),
)
export const InvestorDealVerification = React.lazy(() =>
  import('../pages/Investor/InvestorDeals/InvestorDealVerificationFlow/InvestorDealVerificationFlow.js'),
)

export const InvestorHistory = React.lazy(() => import('../pages/Investor/InvestorDeals/InvestorHistory'))
export const InvestorTaxes = lazy(() => import('../pages/Investor/InvestorSetting/InvestorTaxes'))

export const InvestorSettings = React.lazy(() =>
  import('../pages/Investor/InvestorSetting/InvestorProfileSettingMain.js'),
)
export const InvestorNotifications = React.lazy(() =>
  import('../pages/Investor/InvestorNotifications/InvestorNotifications'),
)
export const InvestorDeals = React.lazy(() => import('../pages/Investor/InvestorDeals/InvestorDeals'))
export const InvestorStepPage = React.lazy(() =>
  import('../pages/Investor/InvestorStepPage/InvestorStepPage'),
)

export const Step12AccreditionStatus = React.lazy(() =>
  import('../pages/InvestorOnboarding/Step12AccreditionStatus/Step12AccreditionStatus'),
)

export const LoginInvestor = React.lazy(() => import('../components/LoginForm/LoginInvestor'))
